import React from 'react'
import { Button } from 'react-bootstrap'
import { useStateValue } from '@State'
import { toast } from '@CommonComponents/toast'

export const DownloadLinks = () => {
  const [currentState] = useStateValue()

  const downloadNotification = () => {
    toast.info("Downloading Roster - Your download should start momentarily.")
  }

  return (
    <div>
      <h4>Download</h4>
      <a
        href={`/instructor/people.download_roster/${currentState.coursenum}/xlsx/`}
      >
        <Button variant="link" onClick={downloadNotification}>
          <i className="fa-light fa-fw fa-file-excel" /> Download Student Roster
          (.xlsx)
        </Button>
      </a>
      <a
        href={`/instructor/people.download_roster/${currentState.coursenum}/csv/`}
      >
        <Button variant="link" onClick={downloadNotification}>
          <i className="fa-light fa-fw fa-file-csv" /> Download Student Roster
          (.csv)
        </Button>
      </a>
    </div>
  )
}
